import React from 'react';
import { Minus, Plus } from 'lucide-react';

const QuantitySelector = ({ quantity, onIncrease, onDecrease, min = 1, max = 99 }) => {
  return (
    <div className="flex items-center border-2 border-aug-sand rounded-lg overflow-hidden">
      <button
        onClick={onDecrease}
        disabled={quantity <= min}
        className="bg-aug-cream hover:bg-aug-salmon w-10 h-12 flex items-center justify-center transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="qty-decrease"
      >
        <Minus className="w-4 h-4 text-aug-gray-dark" />
      </button>
      
      <input
        type="number"
        value={quantity}
        readOnly
        className="w-16 h-12 text-center border-none text-lg font-semibold text-aug-gray-dark"
        data-testid="qty-input"
      />
      
      <button
        onClick={onIncrease}
        disabled={quantity >= max}
        className="bg-aug-cream hover:bg-aug-salmon w-10 h-12 flex items-center justify-center transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="qty-increase"
      >
        <Plus className="w-4 h-4 text-aug-gray-dark" />
      </button>
    </div>
  );
};

export default QuantitySelector;